import React from "react"

const Sponsors = () => {
  return (
    <div className="sponsors">
      <div className="content">
        <h2>Gala Sponsors</h2>
        <ul className="list-sponsors">
          <li>
            <h3>Underwriting Sponsor</h3>
            <ul className="list-images">
              <li>
                <img
                  className="sponsor-max-width"
                  src="./inmaat.png"
                  alt="InMaat"
                />
              </li>
            </ul>
          </li>
          <li>
            <h3>Champion of Change</h3>
            <ul className="list-img">
              <li>
                <img
                  className="large-max-width"
                  src="./gucci.png"
                  alt="gucci"
                />
              </li>
              <li>
                <img
                  className="sponsor-max-width"
                  src="./chime.png"
                  alt="Chime"
                />
              </li>
            </ul>
          </li>
          <li>
            <h3>Change Advocate</h3>
            <strong className="sponsor-title">Nancy & Jeffrey Goldstein</strong>
            <strong className="sponsor-title">Karen Lehner</strong>
            <ul className="padding-top-xsmall">
              <li>
                <img
                  className="sponsor-max-width"
                  src="./polk.png"
                  alt="Polk"
                />
              </li>
            </ul>
          </li>

          <li>
            <h3>Change Agent</h3>
            <strong className="sponsor-title">
              Paula Ravets & Paul Reiser
            </strong>
            <strong className="sponsor-title">Jessica Rothenberg-Aalami</strong>
            <strong className="sponsor-title">Smalley-Wall Family</strong>
            <strong className="sponsor-title">Amy Ziering</strong>
          </li>
          <li>
            <h3>Change Supporter</h3>
            <strong className="sponsor-title">Elisa deLaet Jagerson</strong>
            <strong className="sponsor-title">
              Ann MacDougall & Jules Kaufman
            </strong>
            <strong className="sponsor-title">Dan & Annette Kelly</strong>
            <strong className="sponsor-title">Simone Lahorgue</strong>
            <strong className="sponsor-title">Janvi Patel</strong>
            <strong className="sponsor-title">
              Julia Beardwood & Jonathan Willens
            </strong>
            <ul className="">
              <li>
                <img
                  className="sponsor-max-width-large"
                  src="./LAPA_logo-removebg-preview.png"
                  alt="LAPA"
                />
              </li>
            </ul>
          </li>
        </ul>
        <ul className="list">
          <li>
            <h3>Host Committee</h3>
            <p>
              Margaret Atwood | Elisa deLaet Jagerson | Jane Fonda | Nancy &
              Jeffrey Goldstein | Chandra Jessee | Ann MacDougall & Jules
              Kaufman | Dan & Annette Kelly | Simone Lahorgue | LAPA Fundraising
              | Karen Lehner | Janvi Patel | Paula Ravets | Jessica
              Rothenberg-Aalami | Sheetal Sheth | Sue Smalley | Jennifer Allan
              Soros | Gloria Steinem | Julia Beardwood & Jonathan Willens | Amy
              Ziering
            </p>
          </li>
          <li>
            <h3>Special Thanks</h3>
            <p>
              Rachel Decker <br /> Stephanie Green <br />
              Ali Werner <br /> Strike Audio
            </p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Sponsors
